import type { EnvironmentProviders, Provider } from '@angular/core';
import { provideApollo as provideApolloLibrary } from 'apollo-angular';
import { apolloFactory } from './apollo.factory';
import { auroraGraphqlErrorHandlerFactory } from './handlers/aurora-graphql-error.handler';
import { GRAPHQL_ERROR_HANDLER } from './handlers/graphql.tokens';

export const provideApollo = (): Array<Provider | EnvironmentProviders> => [
  provideApolloLibrary(() => apolloFactory()),
  // Default GraphQL error presentation (Spartan sonner toasts). Apps may override
  // GRAPHQL_ERROR_HANDLER to present errors differently.
  { provide: GRAPHQL_ERROR_HANDLER, useFactory: auroraGraphqlErrorHandlerFactory },
];
